const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};

export const questionScoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_QUESTION_SCORE_PENDING': {
      return { ...state, fetching: true };
    }
    case 'FETCH_QUESTION_SCORE_FULFILLED': {
      const { data, nbResult } = action.payload;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult,
      };
    }
    case 'FETCH_QUESTION_SCORE_REJECTED': {
      let error = action.payload;
      switch (error.response?.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        error,
      };
    }
    default:
      return state;
  }
};
